module.exports = __webpack_public_path__ + "static/img/logo102.010995a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo102.png
// module id = zcoF
// module chunks = 1